import useInbox from "../useInbox";

const useCommonInbox = ({ tenantId, filters, config, userBusinessServices }) => {
  const { applicationStatus, mobileNumber, applicationNumber, sortBy, sortOrder, locality, uuid, limit, offset } = filters;
  const USER_UUID = Digit.UserService.getUser()?.info?.uuid;
  const excludedServices = ["BPA_NOC_acquisitionSection"];

  // const currentBusinessService = userBusinessServices?.filter((item) => !excludedServices.includes(item));
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: userBusinessServices,
      ...(applicationStatus?.length > 0 ? { status: applicationStatus } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? { assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : "" } : {}),
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? { mobileNumber } : {}),
      ...(applicationNumber ? { applicationNumber } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortOrder ? { sortOrder } : {}),
      ...(locality?.length > 0 ? { locality: locality.map((item) => item.name.split("_").pop()).join(",") } : {}),
    },
    limit,
    offset,
  };

  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: (data) => ({
        statuses: data.statusMap,
        table: data?.items.map((application) => ({
          applicationId: application.businessObject.applicationNo,
          date: application.businessObject.auditDetails.createdTime,
          businessService: application.businessObject.businessService,
          status: application.businessObject.status,
          proposedActivity: application?.businessObject?.activityProposed,
          plotArea:
            application?.businessObject?.plotArea ||
            application?.businessObject?.descriptionOfLand?.landArea ||
            application?.businessObject?.descriptionOfLand?.totalPlotArea,
          schemeName: application?.businessObject?.schemeName,
          plotNo: application?.businessObject?.plotNo,
          owner: application.businessObject?.landInfo?.owners?.[0]?.name,
          emailId: application.businessObject?.landInfo?.owners?.[0]?.emailId,
          applicationType: application?.businessObject?.applicationType,
          userPhoto: application.businessObject?.landInfo?.owners?.[0]?.photo,
          location: application?.businessObject?.location1,
          registrationNo: application?.businessObject?.registrationNo,
          nextAction: application.ProcessInstance?.nextActions?.[0]?.action,
          department: application?.businessObject?.department,
          land_Id: application?.businessObject?.land_Id,
          ltpName: application?.businessObject?.professionaldetails?.name || application?.businessObject?.professionalInformation?.name,
          recievedTime: application?.businessObject?.auditDetails?.lastModifiedTime,
        })),
        totalCount: data.totalCount,
      }),
      ...config,
    },
  });
};

export default useCommonInbox;
